import { useContext, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { Form, Text } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { serverErrorHandler } from '../../../Utils/Helpers';
import { LevelContext } from '../Context/LevelContext';

const validationSchema = Yup.object({
  title: Yup.string()
    .typeError('عنوان الزامی است')
    .required('عنوان الزامی است')
    .max(190, 'عنوان نمی تواند بیشتر از 190 کاراکتر باشد'),
});

const Edit = () => {
  const { id } = useParams();
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { get, put } = useApi();
  const { error, success } = useToast();
  const context = useContext(LevelContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      await getLevel();
    };
    getData();
  }, [id]);

  const getLevel = async () => {
    setLoading(true);
    await get(
      `/level/${id}`,
      (res) => {
        context.level = res.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    await put(
      `/level/${id}`,
      values,
      (res) => {
        success(`سطح مسابقات "${context?.level?.title}" باموفقیت ویرایش شد.`);
        setFormSubmitLoaing(false);
        getLevel();
      },
      (err) => {
        console.log(err);
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`سطح مسابقات "${context?.level?.title}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <TitleBar
        title={`ویرایش سطح مسابقات ${context.level?.title} `}
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/level'
      />
      <Form
        initialValues={{
          title: context?.level?.title ?? '',
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='col-12'>
                <Text
                  title='عنوان'
                  name='title'
                  serverError={serverErrors.title}
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-4'></div>
        </div>
      </Form>
    </Master>
  );
};

export default Edit;
